export default __webpack_public_path__ + "static/media/mail.31d14d95.svg";